import React from 'react';
import Header from './Header';
import Recommended from './Recommended';
import NewDonors from './NewDonors';
import SearchConds from './SearchConds';
import Footer from '../../components/Footer';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const SearchDonor = () => {
  useTitle('Ton Bébé | ドナーを探す');
  useMetaDescription('Ton Bébéでドナーを探す。地域や血液型、性病・精液検査結果などの条件からご希望に合う精子ドナーを検索できます。');

  return (
    <div>
      <Header />
      <main className="sub">
        <section className="archive_search">
          <h1 className="sec_title">ドナーを探す</h1>
          <Recommended />
          <NewDonors />
          <SearchConds />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default SearchDonor;
